import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5850c0c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-mb-0 p-text-center" }
const _hoisted_2 = { class: "p-text-center p-mb-3" }
const _hoisted_3 = {
  autocomplete: "off",
  class: "p-grid p-p-lg-5 p-p-3"
}
const _hoisted_4 = { class: "p-inputgroup" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" })
], -1))
const _hoisted_6 = { class: "p-inputgroup p-mt-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" })
], -1))
const _hoisted_8 = { class: "p-inputgroup p-mt-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-eye" })
], -1))
const _hoisted_10 = { class: "p-pl-2 p-ml-2 p-mt-0" }
const _hoisted_11 = { class: "p-inputgroup p-mt-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-eye" })
], -1))
const _hoisted_13 = { class: "p-inputgroup p-mt-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bars" })
], -1))
const _hoisted_15 = { class: "p-d-flex p-jc-around p-ai-baseline p-col-12 p-mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FieldErrors = _resolveComponent("FieldErrors")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("signUp.welcome")), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("signUp.startTrial")), 1),
    _createElementVNode("form", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            class: "p-col-12",
            mode: "indeterminate",
            style: {"height":"0.5em"}
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_InputText, {
          "model-value": _ctx.form.name.$value,
          placeholder: _ctx.$t('signUp.name'),
          class: _normalizeClass({ 'p-invalid': _ctx.form.name.$hasError }),
          onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.form.name.$value = ($event.target as any).value)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.onKeyEnter('name', ($event.target as any).value)), ["enter"])),
          "aria-describedby": "username2-help"
        }, null, 8, ["model-value", "placeholder", "class"])
      ]),
      _createVNode(_component_FieldErrors, {
        errors: _ctx.form.name.$errors
      }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_InputText, {
          "model-value": _ctx.form.email.$value,
          placeholder: _ctx.$t('signUp.email'),
          class: _normalizeClass({ 'p-invalid': _ctx.form.email.$hasError }),
          onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.email.$value = ($event.target as any).value)),
          onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.onKeyEnter('email', ($event.target as any).value)), ["enter"])),
          disabled: _ctx.form.activation === 1
        }, null, 8, ["model-value", "placeholder", "class", "disabled"])
      ]),
      _createVNode(_component_FieldErrors, {
        errors: _ctx.form.email.$errors
      }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_Password, {
          modelValue: _ctx.form.password.$value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.password.$value) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.form.password.$hasError }),
          onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (
          _ctx.onKeyEnter(
            'password',
            ($event.target as any).value || ($event.target as any)._value
          )
        ), ["enter"])),
          placeholder: _ctx.$t('signUp.password')
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Divider, { style: {"background":"gainsboro","height":"1px"} }),
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('validation.validPassword'), (m, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(m), 1))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "class", "placeholder"])
      ]),
      _createVNode(_component_FieldErrors, {
        errors: _ctx.form.password.$errors
      }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_InputText, {
          type: "password",
          modelValue: _ctx.form.confirm.$value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.confirm.$value) = $event)),
          placeholder: _ctx.$t('signUp.confirm'),
          class: _normalizeClass({ 'p-invalid': _ctx.form.confirm.$hasError }),
          onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.onKeyEnter('confirm', ($event.target as any).value)), ["enter"]))
        }, null, 8, ["modelValue", "placeholder", "class"])
      ]),
      _createVNode(_component_FieldErrors, {
        errors: _ctx.form.confirm.$errors
      }, null, 8, ["errors"]),
      (!_ctx.instigatorId)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_InputText, {
                type: "number",
                "model-value": (_ctx.form.instigatorId.$value as any),
                placeholder: _ctx.$t('signUp.codePromo'),
                class: _normalizeClass({ 'p-invalid': _ctx.form.instigatorId.$hasError }),
                onBlur: _cache[8] || (_cache[8] = ($event: any) => (
            _ctx.form.instigatorId.$value = _ctx.getInstigator(
              ($event.target as any).value
            )
          )),
                onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (
            _ctx.onKeyEnter(
              'instigatorId',
              _ctx.getInstigator(($event.target as any).value)
            )
          ), ["enter"]))
              }, null, 8, ["model-value", "placeholder", "class"])
            ]),
            _createVNode(_component_FieldErrors, {
              errors: _ctx.form.instigatorId.$errors
            }, null, 8, ["errors"])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_Button, {
          type: "button",
          icon: "pi pi-send",
          label: _ctx.$t('signUp.signUp'),
          class: "p-button-rounded p-button-outlined",
          "icon-pos": "right",
          loading: _ctx.loading,
          disabled: _ctx.loading,
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.submit()))
        }, null, 8, ["label", "loading", "disabled"]),
        _createVNode(_component_router_link, {
          to: `${_ctx.accountBaseUrl}/sign-in`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("signUp.haveAccount")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ], 64))
}